import { apiClient } from '@/shared/api';

/**
 * Feature-local tenant-location lookup (id → name/code) for the group editor — the same
 * single-page `/api/v1/store/locations/search` read `features/inventory/api/locationsApi.ts`
 * documents (FSD forbids the cross-feature import; the accepted >100-locations limitation and its
 * rationale live there).
 */
export interface LocationOption {
  id: string;
  code: string;
  name: string;
  active: boolean;
}

const MAX_SEARCH_SIZE = 100;

export const searchLocations = async (): Promise<LocationOption[]> => {
  const { data } = await apiClient.post<{ items: LocationOption[] }>(
    '/api/v1/store/locations/search',
    { size: MAX_SEARCH_SIZE },
  );
  return data.items.map(({ id, code, name, active }) => ({ id, code, name, active }));
};
